import { render, staticRenderFns } from "./ApplicationEvents.vue?vue&type=template&id=5c95a5bc&"
import script from "./ApplicationEvents.vue?vue&type=script&lang=js&"
export * from "./ApplicationEvents.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports